export var tableHeader = function tableHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.5em',
    padding: '1.2em 2em',
    marginBottom: '1em',
    backgroundColor: theme.infoLight,
    border: "1px solid ".concat(theme.info),
    '& p': {
      margin: 0,
      fontSize: '1.25rem',
      color: theme.gray600,
      lineHeight: 1.5
    },
    '& .info-icon': {
      fontSize: '2rem',
      color: theme.info,
      flexShrink: 0
    }
  };
};
export var tableWrap = {
  overflowX: 'auto',
  marginBottom: '2em'
};
export var reportTable = function reportTable(theme) {
  return {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '1.25rem',
    '& thead': {
      backgroundColor: theme.gray50,
      '& th': {
        padding: '1em 0.8em',
        fontWeight: 600,
        color: theme.gray400,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        borderBottom: "2px solid ".concat(theme.gray100)
      }
    },
    '& tbody': {
      '& tr': {
        borderBottom: "1px solid ".concat(theme.gray100),
        transition: 'background-color 0.15s ease',
        '&:hover': {
          backgroundColor: theme.gray50
        }
      },
      '& td': {
        padding: '0.9em 0.8em',
        color: theme.gray700,
        whiteSpace: 'nowrap'
      }
    }
  };
};